import Spinner from "@/components/Spinner";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { toast } from "sonner";
import { endpoints } from "../../../hooks/endpoints";
import { dateFormatter, getToken } from "../../../hooks/utils";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import {
  invokePortalRefetch,
  invokeUserRefetch,
} from "../../../store/slices/storeSlice";
import Animation from "../../Animation";
import DynamicCategorySelector from "../DynamicCategorySelector";
import { LessonType } from "./CreateLessonWrapper";

const CreateLiveLesson = ({
  setSessionType,
}: {
  setSessionType: (x: LessonType | null) => void;
}) => {
  const [selectedDate, setSelectedDate] = useState<string | null>(null);
  // const [isLessonFree, setIsLessonFree] = useState<boolean>(false);
  const [isPending, setIsPending] = useState<boolean>(false);
  const [resMsg, setResMsg] = useState<{ ok: boolean; message: string }>(null);

  const { portal } = useAppSelector((state) => state.store);
  const dispatch = useAppDispatch();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsPending(true);
    setResMsg(null);

    const formData = new FormData(e.currentTarget);
    const data = Object.fromEntries(formData);
    console.log(data);
    fetch(endpoints.createLiveSession, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: getToken(),
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((data) => {
        setResMsg({ ok: true, message: data.message });
        toast.success(
          <span className="text-green-700 text-md">{data.message}</span>
        );
        dispatch(invokeUserRefetch());
        dispatch(invokePortalRefetch());
      })
      .catch((err) => {
        setResMsg({ ok: false, message: err.message });
        toast.error(
          <span className="text-red-700 text-md">{err.message}</span>
        );
        console.log(err.data);
      })
      .finally(() => setIsPending(false));
  };

  return (
    <Animation>
      <div className="space-y-6">
        <h3 className="bg-primary p-3 text-white rounded-lg shadow font-bold flex items-center">
          <p className="flex-1 p-0 m-0">تحديد موعد حصة لايف جديدة</p>
          <button
            type="button"
            className="m-0 p-0"
            onClick={() => setSessionType(null)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              fill="white"
              viewBox="0 0 16 16"
            >
              <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
            </svg>
          </button>
        </h3>
        <form
          onSubmit={handleSubmit}
          className="p-3 bg-white rounded-lg border shadow-sm elite-form space-y-4"
        >
          <div className="flex flex-col gap-2">
            <label htmlFor="session_title" className="block font-medium">
              إسم الحصة
            </label>
            <input
              type="text"
              id="session_title"
              name="session_title"
              className="block w-full border rounded-lg px-3 py-2"
              required
            />
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="session_category" className="block font-medium">
              المجموعة
            </label>
            <DynamicCategorySelector
              excludeCatsThatHasLessons={false}
              catFieldName="session_category"
            />
            {/* <select
              id="session_category"
              name="session_category"
              className="block w-full border rounded-lg px-3 py-2"
              required
            >
              <option disabled selected>
                المجموعة
              </option>
              {portal?.cats
                .filter((item) => item.parent !== 0)
                ?.map((cat) => (
                  <option key={cat.term_id} value={cat.term_id}>
                    {cat.name.indexOf("|") === -1
                      ? cat.name
                      : cat.name.split("|")[0]}
                  </option>
                ))}
            </select> */}
          </div>

          <div className="flex flex-col gap-2">
            <label htmlFor="session_start_date" className="block font-medium">
              تاريخ بدء الحصة
            </label>
            <input
              type="datetime-local"
              id="session_start_date"
              name="session_start_date"
              className="block w-full border rounded-lg px-3 py-2 text-right"
              onChange={(e) => setSelectedDate(e.target.value)}
              required
            />
          </div>

          {!!selectedDate && (
            <p>تبدأ الحصة: {dateFormatter(selectedDate, true, true)}</p>
          )}

          <div className="flex flex-col gap-2">
            <label htmlFor="session_duration" className="block font-medium">
              مدة الحصة بالدقائق
            </label>
            <input
              type="number"
              id="session_duration"
              name="session_duration"
              className="block w-full border rounded-lg px-3 py-2"
              min={30}
              max={240}
              required
            />
          </div>

          <p className="text-red-600 text-base">
            هام: المدة القصوى للحصة هي أربع (٤) ساعات
          </p>

          <div className="flex flex-col gap-2">
            <label htmlFor="session_price" className="block font-medium">
              سعر الحصة
            </label>
            <input
              type="number"
              id="session_price"
              name="session_price"
              className="block w-full border rounded-lg px-3 py-2"
              min={1}
              required
            />
          </div>

          <Button
            type="submit"
            id="publish_new_quiz_submit"
            className="w-full rounded-lg"
            disabled={isPending}
          >
            {isPending ? <Spinner variant="button" /> : "جدول الحصة"}
          </Button>

          {/* {!!resMsg && (
            <div
              className={`mt-2 rounded-lg p-3 ${
                resMsg.ok
                  ? "bg-green-100 text-green-800"
                  : "bg-red-100 text-red-800"
              }`}
              role="alert"
            >
              {resMsg.message}
            </div>
          )} */}
        </form>
      </div>
    </Animation>
  );

  return (
    <Animation>
      <div className="create-lesson">
        <form
          onSubmit={handleSubmit}
          className="m-3 p-3 bg-white rounded-lg shadow elite-form"
        >
          <h3 className="mt-3 mb-4 bg-primary p-3 text-white rounded-lg shadow fw-bold d-flex">
            <p
              style={{
                flex: 1,
                padding: 0,
                margin: 0,
              }}
            >
              تحديد موعد حصة لايف جديدة
            </p>
            <button
              className="btn m-0 p-0"
              onClick={() => setSessionType(null)}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="30"
                fill="white"
                className="bi bi-arrow-left-circle-fill"
                viewBox="0 0 16 16"
              >
                <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5z" />
              </svg>
            </button>
          </h3>
          <div className="form-floating mb-3">
            <input
              type="text"
              className="form-control rounded-lg"
              name="session_title"
              placeholder="session_title"
              required
            />
            <label htmlFor="session_title">إسم الحصة</label>
          </div>
          <select
            name="session_category"
            className="form-select mb-3 rounded-lg"
            aria-label="المجموعة"
            required
          >
            <option disabled selected>
              المجموعة
            </option>
            {portal?.cats
              .filter((item) => item.parent !== 0)
              ?.map((cat) => (
                <option value={cat.term_id}>
                  {cat.name.indexOf("|") === -1
                    ? cat.name
                    : cat.name.split("|")[0]}
                </option>
              ))}
          </select>
          <div className="form-floating mb-3">
            <input
              type="datetime-local"
              id="session_start_date"
              name="session_start_date"
              className="form-control rounded-lg"
              onChange={(e) => setSelectedDate(e.target.value)}
              style={{ textAlign: "right" }}
              required
            ></input>
            <label htmlFor="session_start_date">تاريخ بدء الحصة</label>
          </div>
          {!!selectedDate && (
            <p>تبدأ الحصة: {dateFormatter(selectedDate, true, true)}</p>
          )}
          <div className="form-floating mb-3">
            <input
              type="number"
              id="session_duration"
              name="session_duration"
              className="form-control rounded-lg"
              min={30}
              max={300}
              required
            ></input>
            <label htmlFor="session_duration">مدة الحصة بالدقائق</label>
          </div>
          {/* <Separator /> */}
          {/* <div className="form-check form-switch mb-3">
            <input
              className="form-check-input"
              type="checkbox"
              id="isLessonFree"
              name="isLessonFree"
              onChange={(e) => setIsLessonFree(e.target.checked)}
            />
            <label className="form-check-label ms-1" htmlFor="isLessonFree">
              هل الحصة مجانية
            </label>
          </div> */}
          {/* {!isLessonFree && ( */}
          {/* <> */}
          {/* {portal?.allowed_payment_methods?.map((method) => (
            <div className="form-check form-switch my-3">
              <input
                className="form-check-input"
                type="checkbox"
                id={`payment_method_${method}`}
                name={`payment_method_${method}`}
                checked={
                  portal?.allowed_payment_methods.length === 1 &&
                  portal?.allowed_payment_methods[0] === "code"
                    ? true
                    : undefined
                }
              />
              <label
                className="form-check-label ms-1"
                htmlFor={`payment_method_${method}`}
              >
                {`تفعيل الدفع بال${payment_methods[method]}`}
              </label>
            </div>
          ))} */}
          <div className="form-floating mb-3">
            <input
              type="number"
              id="session_price"
              name="session_price"
              className="form-control rounded-lg"
              min={1}
              required
            ></input>
            <label htmlFor="session_price">سعر الحصة</label>
          </div>
          {/* </> */}
          {/* )} */}
          <input
            type="submit"
            id="publish_new_quiz_submit"
            className={`ea-btn btn w-100 rounded-lg ${isPending && "loading"}`}
            value="جدول الحصة"
          />
          {!!resMsg && (
            <div
              className={`alert alert-${
                resMsg.ok ? "success" : "danger"
              } h-50 mt-2 rounded-lg`}
              role="alert"
            >
              {resMsg.message}
            </div>
          )}
        </form>
      </div>
    </Animation>
  );
};

export default CreateLiveLesson;
